import {Component, Inject, Input, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {FormControl, FormGroup, ValidationErrors, Validators} from '@angular/forms';
import {KeyVarElement, Program, ProgramDialogData} from '../../../domain/cloud-topology';
import {
  cancelStatus,
  COINCIDENT_PEAK,
  DEMAND_RESPONSE,
  performanceTarget,
  pointOfMeasurement,
  programTypes, saveStatus
} from '../../../domain/constants';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

@Component({
    selector: 'app-program-edit-modal',
    templateUrl: 'program-edit-modal.component.html',
    styleUrls: ['program-edit-modal.component.scss'],
    standalone: false
})
export class ProgramEditModalComponent implements OnInit {
  program: Program;
  programForm: FormGroup;
  programTypes: KeyVarElement[];
  pointOfMeasurement: KeyVarElement[];
  performanceTarget: KeyVarElement[];
  constructor(public dialogRef: MatDialogRef<MatDialogRef<ProgramEditModalComponent>>,
              @Inject(MAT_DIALOG_DATA) public dialogData: ProgramDialogData) { }

  ngOnInit(): void {
    this.programTypes = programTypes;
    this.pointOfMeasurement = pointOfMeasurement;
    this.performanceTarget = performanceTarget;
    if (!this.dialogData.program) {
      this.programForm = new FormGroup({
        name: new FormControl('', Validators.required),
        programType: new FormControl(DEMAND_RESPONSE, Validators.required),
        notificationTimeframe: new FormControl('', Validators.required),
        marketAuction: new FormControl(false, Validators.required),
        nominatedKw: new FormControl('', Validators.required),
        pointOfMeasurement: new FormControl('', Validators.required),
        performanceTarget: new FormControl('', Validators.required),
        incentive: new FormControl(0, [Validators.required, Validators.min(0)]),
        penalty: new FormControl(0, [Validators.required, Validators.min(0)]),
        forwardStats: new FormControl(''),
        forceMaxDispatch: new FormControl('')
      });
    } else {
      this.program = this.dialogData.program;
      this.programForm = new FormGroup({
        name: new FormControl(this.program.name, Validators.required),
        programType: new FormControl(this.program.programType, Validators.required),
        nominatedKw: new FormControl(this.program.properties.nominatedKw, Validators.required),
        pointOfMeasurement: new FormControl(this.program.properties.pointOfMeasurement, Validators.required),
        performanceTarget: new FormControl(this.program.properties.performanceTarget, Validators.required),
        notificationTimeframe: new FormControl(this.program.properties.notificationTimeframe, Validators.required),
        marketAuction: new FormControl(this.program.properties.marketAuction, Validators.required),
        incentive: new FormControl(this.program.properties.programIncentive, [Validators.required, Validators.min(0)]),
        penalty: new FormControl(this.program.properties.programPenalty, [Validators.required, Validators.min(0)]),
        forwardStats: new FormControl((this.program.properties.forwardStats) ? JSON.parse(String(this.program.properties.forwardStats)) : false),
        forceMaxDispatch: new FormControl((this.program.properties.forceMaxDispatch) ? JSON.parse(String(this.program.properties.forceMaxDispatch)) : false)
      });
    }

    this.checkProgramType();
  }

  close(): void {
    this.dialogRef.close({
      program: this.program,
      status: cancelStatus,
    });
  }

  save(): void {
    this.dialogRef.close({
      program: this.programForm.value,
      status: saveStatus
    });
  }

  checkProgramType() {
    if (this.programForm.get('programType').value == COINCIDENT_PEAK) {
      this.programForm.get('forceMaxDispatch').disable();
    } else {
      this.programForm.get('forceMaxDispatch').enable();

    }
  }
}
